export const formattedItems = (items: string[]): string => {
  //@ts-expect-error:skip
  const itemNames = items.slice(0, 2).map((item) => item.name);
  return items.length > 2
    ? `${itemNames.join(", ")} ...`
    : itemNames.join(", ");
};
